/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
import { produce } from 'immer';

import {
  CHART_SUBSCRIPTION_PAYLOAD,
  TOGGLE_FULL_SCREEN_MODE,
  SET_CHART_ACTIVE_TAB,
  SET_CHART_SCROLLING,
  SET_CHART_FROZEN,
  TOGGLE_PLACE_ORDER_SECTION,
  SET_CHART_COUNT,
  SET_CLOSE_POSITION_POPUP,
} from 'actionTypes/tradingView';
import { CHART_TABS } from 'constants/enums';

const initialState = {
  isReady: true,
  shouldShowClosePositionPopup: false,
  markPriceChart: null,
  chartSubscriptionPayload: {},
  isFullScreen: false,
  activeTab: CHART_TABS.PRICE_CHART,
  isChartScrolling: false,
  isChartFrozen: false,
  showPlaceOrderSection: true,
  chartCount: {
    futures: 1,
    options: 1,
    tracker: 1,
    default: 1,
  },
};

// eslint-disable-next-line default-param-last
const tradingView = produce((state = initialState, action) => {
  switch (action.type) {
    case 'TRADING_VIEW_READY': {
      state.isReady = true;
      break;
    }
    case CHART_SUBSCRIPTION_PAYLOAD: {
      state.chartSubscriptionPayload = action.payload;
      break;
    }
    case TOGGLE_FULL_SCREEN_MODE: {
      state.isFullScreen = action.payload.isFullScreen;
      state.activeTab = action.payload.activeTab;
      break;
    }
    case SET_CHART_ACTIVE_TAB: {
      state.activeTab = action.payload;
      break;
    }
    case SET_CHART_SCROLLING: {
      state.isChartScrolling = action.payload;
      break;
    }
    case SET_CHART_FROZEN: {
      state.isChartFrozen = action.payload;
      break;
    }
    case TOGGLE_PLACE_ORDER_SECTION: {
      state.showPlaceOrderSection = action.payload;
      break;
    }
    case SET_CHART_COUNT: {
      const { containerType, chartCount } = action.payload;
      state.chartCount[containerType] = chartCount;
      break;
    }
    case SET_CLOSE_POSITION_POPUP: {
      state.shouldShowClosePositionPopup = action.payload;
      break;
    }
    default:
      return state;
  }
});

export default tradingView;
